import { Component, ChangeDetectionStrategy, output, signal, computed } from '@angular/core';
import moment from 'moment';

import { ContactRegionalComponent } from './contact-regional/contact-regional.component';
import { EditorialStaffComponent } from './editorial-staff/editorial-staff.component';
import { TranslatePipe } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { PagesState } from '../../state/pages/pages.state';

@Component({
    selector: 'app-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ContactRegionalComponent, EditorialStaffComponent, TranslatePipe]
})
export class BottomNavigationComponent {
    public readonly expandedChange = output<boolean>();

    private readonly lastupload = select(PagesState.lastupload);
    protected readonly lastupdate = computed(() => {
        const uploadedAt = this.lastupload();
        return uploadedAt ? moment(uploadedAt, 'DD.MM.YYYY HH:mm:ss').utc().format('YYYY-MM-DD HH:mm') : '';
    });
    protected readonly regionalcontacts = select(PagesState.regioncontacts);
    protected readonly editorialdepartment = select(PagesState.editorialdepartment);
    protected readonly showRegionalContacts = signal(false);
    protected readonly showEditorialDepartment = signal(false);
    protected readonly isExpanded = computed(() => this.showRegionalContacts() || this.showEditorialDepartment());

    protected openContactRegional(): void {
        this.showRegionalContacts.update(v => !v);
        this.showEditorialDepartment.set(false);
        this.expandedChange.emit(this.isExpanded());
    }

    protected openEditorials(): void {
        this.showEditorialDepartment.update(v => !v);
        this.showRegionalContacts.set(false);
        this.expandedChange.emit(this.isExpanded());
    }
}
